import * as Yup from 'yup';

export const numberSchema = Yup.number().typeError('Invalid number');

export const positiveNumberSchema = numberSchema
  .integer('Number must be a whole number')
  .min(1, 'Number must be positive');

export const nonNegativeNumberSchema = positiveNumberSchema
  .integer('Number must be a whole number')
  .min(0, 'Number must be non-negative');
